import Repository from './Repository'

export default {
  getNotificationList() {
    return Repository.private().get(`/user/notifications/`)
  },
  readNotification(code) {
    return Repository.private().put(`/user/notifications/${code}`)
  },
  seenAllNotifications() {
    return Repository.private().put(`/user/notifications/`)
  }
}
